<template>
  <div class="col-xs-12 col-md-4 col-lg-4 text-center">
    <a class="btn btn-primary btn-lg" href="https://grotec.co.uk/shop">Reserve a Collection <i
        class="fa fa-briefcase"></i> </a>
    <!--<h3 class="text-center">Opening Hours</h3>-->
    <br/><br/>
    <p>Please book a time to collect from<br/>
      the shop using the above button</p>
    <div class="caption" style="margin-bottom: 52px;">
      <h3 class="text-center">Opening Hours</h3>
      <span class="text-center">
                                <h5 class="shop-information" itemprop="openingHours"
                                    datetime="Mo,Tu,We,Fr,Sa 10:00-18:00">Mon - Fri &nbsp;10am - 6pm</h5>
                                <h5 class="shop-information" itemprop="openingHours" datetime="Th 10:00-19:00"> Thursdays 10am - 7pm</h5>
                                <h5 class="shop-information" itemprop="openingHours"
                                    datetime="Sa, Su 10:00-14:00"> <strong>Sat - Sun 10am - 2pm</strong></h5>

                                </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'opening-times-box'
}
</script>